import React from "react";
import { motion } from "framer-motion";
import { UserRound } from "lucide-react";
import { formatEuro } from "@/lib/format";

export default function ComercialKPIs({ data }) {
  return (
    <div className="space-y-3" data-testid="comercial-kpis-section">
      <h2 className="font-display text-xl font-bold tracking-tight">Lucro por Comercial</h2>
      {!data || data.length === 0 ? (
        <div className="rounded-xl border border-dashed border-border bg-card p-5 text-sm text-muted-foreground"
          data-testid="comercial-kpis-empty">
          Atribua nomes de comerciais nas colunas de lucro (editáveis na tabela) para ver o total acumulado por cada comercial.
        </div>
      ) : (
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-3">
          {data.map((c, i) => (
            <motion.div key={c.nome} initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }}
              transition={{ delay: i * 0.04 }}
              className="rounded-xl border border-border bg-card p-4" data-testid={`comercial-kpi-${c.nome}`}>
              <div className="flex items-center gap-2 mb-2">
                <span className="h-8 w-8 rounded-lg bg-primary/10 flex items-center justify-center text-primary shrink-0">
                  <UserRound className="h-4 w-4" />
                </span>
                <span className="text-sm font-semibold truncate" title={c.nome}>{c.nome}</span>
              </div>
              <div className="font-mono-num text-xl font-bold tracking-tight">{formatEuro(c.total)}</div>
              <div className="text-xs text-muted-foreground mt-1">{c.count} atribuição(ões)</div>
            </motion.div>
          ))}
        </div>
      )}
    </div>
  );
}
